import { render } from "./OrderAssignmentDialog.vue?vue&type=template&id=6dca9067&ts=true"
import script from "./OrderAssignmentDialog.ts?vue&type=script&lang=ts"
export * from "./OrderAssignmentDialog.ts?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__